export const LOADING_AUTO_COMPLETE = 'LOADING_AUTO_COMPLETE';
export const LOAD_AUTO_COMPLETE_SUCCESS = 'LOAD_AUTO_COMPLETE_SUCCESS';
export const LOAD_AUTO_COMPLETE_ERROR = 'LOAD_AUTO_COMPLETE_ERROR';
export const UPDATE_ACTIVE_QUERY = 'UPDATE_ACTIVE_QUERY';

export function updateActiveQuery(payload) {
    return {
        type: UPDATE_ACTIVE_QUERY,
        payload,
    };
}

export function autoCompleteLoadedSuccess(payload) {
    return {
        type: LOAD_AUTO_COMPLETE_SUCCESS,
        payload,
    };
}

export function autoCompleteLoading() {
    return {
        type: LOADING_AUTO_COMPLETE,
        payload: 'LOADING',
    };
}
export function autoCompleteLoadedError(payload) {
    return {
        type: LOAD_AUTO_COMPLETE_ERROR,
        payload,
    };
}
